<div class="not-found-wrapper d-flex flex-column align-items-center justify-content-center">
  <h1 class="not-found-code">404</h1>
  <p class="fs-16 fw-600 mb-1">Page not found</p>
  <p class="fs-14 text-muted mb-4">The page you're looking for doesn't exist or has been moved.</p>
  <button type="button" class="btn btn-primary" (click)="goToDashboard()">Go to Dashboard</button>
</div>
